import React, { useEffect, useRef, useState } from "react";
import { Container} from "react-bootstrap";
import { useRecoilValue } from "recoil";
import { ModeSelector, isMobileSelector } from "../../recoil/selectors";
import styles from "./Methodology.module.scss";
import "aos/dist/aos.css";

const MethodologyDesktop = ({ images }) => {


  const svg1 = useRef(null)
  const svg2 = useRef(null)
  const [scroll1, setScroll1] = useState(false)
  const [scroll2, setScroll2] = useState(false)
  const mode = useRecoilValue(ModeSelector);
  const mobile = useRecoilValue(isMobileSelector)

  useEffect(()=>{
    if(svg1 && svg1.current){
      setScroll1({
        scroll: svg1.current.getBoundingClientRect().top-200,
        height: svg1.current.getBoundingClientRect().height
      })
    }
    if(svg2 && svg1.current){
      setScroll2({
        scroll: svg2.current.getBoundingClientRect().top-250,
        height: svg2.current.getBoundingClientRect().height
      })
    }
  },[])


  let path = document.getElementById('line1');
  let path2 = document.getElementById('line2');

  if(path){
    let pathLength = path.getTotalLength();

    path.style.strokeDasharray = pathLength + ' ' + pathLength;
    path.style.strokeDashoffset = pathLength;
    path.getBoundingClientRect();
    window.addEventListener("scroll", function(e) {
      let scrollPercentage = ((document.documentElement.scrollTop-scroll1.scroll) + document.body.scrollTop) / (scroll1.height);
      // Length to offset the dashes
      let drawLength = pathLength * scrollPercentage;
      path.style.strokeDashoffset = pathLength - drawLength;

      if (scrollPercentage >= 0.99) {
        path.style.strokeDasharray = "none";
      } else {
        path.style.strokeDasharray = pathLength + ' ' + pathLength;
      }
    });
  }
  if(path2){
    let path2Length = path2.getTotalLength();

    path2.style.strokeDasharray = path2Length + ' ' + path2Length;
    path2.style.strokeDashoffset = path2Length;
    path2.getBoundingClientRect();
    window.addEventListener("scroll", function(e) {
      let scrollPercentage2 = ((document.documentElement.scrollTop-scroll2.scroll) + document.body.scrollTop) / (scroll2.height);
      let drawLength2 = path2Length * scrollPercentage2;
      //CAMBIANDO EL ORDEN DE LA RESTA DETERMINA DESDE DONDE HACE EL EFECTO
      path2.style.strokeDashoffset = drawLength2 - path2Length;

      if (scrollPercentage2 >= 0.99) {
        path2.style.strokeDasharray = "none";
      } else {
        path2.style.strokeDasharray = path2Length + ' ' + path2Length;
      }
    });
  }




  return (
      <div>
        <Container
            fluid
            className={`${styles.ContainerMethodology}  onlydesktop`}
            id="methodology"
        >
          <div className={`${styles.container01} parallaxwrap1`}>
            <div className={styles.line1} ref={svg1}>
              <svg xmlns="http://www.w3.org/2000/svg" width="100vw" height="100vh" viewBox="0 0 1452.807 916.946">
                <path id="mask" d="M378,2457.359s-89.672,22.129-78.309,227.45-206.209,269.255,24.514,306.874,108.179,93.462,399.439,76.458,369.585-6.619,513.663,39.637,448.086-139.58,431.6,266.023" transform="translate(-217.237 -2456.874)" fill="none" stroke="#585858" strokeWidth="1" strokeDasharray="8"/>
                <path id="line1" d="M378,2457.359s-89.672,22.129-78.309,227.45-206.209,269.255,24.514,306.874,108.179,93.462,399.439,76.458,369.585-6.619,513.663,39.637,448.086-139.58,431.6,266.023" transform="translate(-217.237 -2456.874)" fill="none" stroke="#585858" strokeWidth="2" strokeDasharray="4"/>
              </svg>
            </div>
            <div className={styles.row01}>
              <div className={styles.number01}>
                <span>01</span>
              </div>
              <div className={styles.text01}>
                <h3> Seed<span>.</span></h3>
                <p> Tienes la idea y brief de un producto digital y quieres probar si funciona su concepto. Necesitas desarrollar un MVP rápido, a bajo costo y sin muchas integraciones, te entendemos.</p>
                <a href="/contact"  rel="noreferrer" className={styles.submit}>
                  Empieza ahora
              </a>
              </div>
              <div  className={`${styles.img01} rellaximgfirst`}>
                {mode === "dark" ? (
                    images["DarkIlustration1"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["DarkIlustration1"].publicURL}
                        />
                    )
                ) : (
                    images["LightIlustration1"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["DarkIlustration1"].publicURL}
                        />
                    )
                )}
              </div>
            </div>
          </div>
          <div className={`${styles.container02} parallaxwrap1`}>
            <div className={styles.row02}>
              <div  className={`${styles.img02} rellaximgfirst`}>
                {!mobile
                    ? mode === "dark"
                        ? images["DarkIlustration2"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["DarkIlustration2"].publicURL}
                        />
                    )
                        : images["LightIlustration2"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["LightIlustration2"].publicURL}
                        />
                    )
                    : images["MobileDark2"] && (
                    <img
                        alt="ilustration_methodology"
                        src={images["MobileDark2"].publicURL}
                    />
                )}
              </div>
              <div className={styles.text02}>
                <h3>Startup<span>.</span>
                </h3>
                <p>Tienes la idea y brief de un producto digital y quieres probar si funciona su concepto. Necesitas desarrollar un MVP rápido, a bajo costo y sin muchas integraciones, te entendemos.</p>
                <a href="/contact"  rel="noreferrer" className={styles.submit}>
                  Empieza ahora
                </a>
              </div>
              <div className={styles.number02}>
                <span>02</span>
              </div>
            </div>
          </div>
          <div className={`${styles.container03} parallaxwrap1`}>
            <div className={styles.line2} ref={svg2}>
              <svg xmlns="http://www.w3.org/2000/svg" width="120vw" height="120vh" viewBox="0 0 1498.674 1234.167">
                <path id="mask2" data-name="Path 43" d="M1592.718,3331.367s19.938-93.707-53.836-166.289-157.5-11.044-301.575-57.3S685.316,3279.2,467.246,3123.758s-43.475-220.67-54.839-425.991-21.634-215.531-19.665-215.613c25.609-213.61,474.541-111.967,748.487-106.348,276.433,5.669,365.09-11.324,464.013-30.16s288.026.017,242.631-248.252" transform="translate(-356.516 -2097.303)" fill="none" stroke="#585858" strokeWidth="1" strokeDasharray="8"/>
                <path id="line2" data-name="Path 43" d="M1592.718,3331.367s19.938-93.707-53.836-166.289-157.5-11.044-301.575-57.3S685.316,3279.2,467.246,3123.758s-43.475-220.67-54.839-425.991-21.634-215.531-19.665-215.613c25.609-213.61,474.541-111.967,748.487-106.348,276.433,5.669,365.09-11.324,464.013-30.16s288.026.017,242.631-248.252" transform="translate(-356.516 -2097.303)" fill="none" stroke="#585858" strokeWidth="2" strokeDasharray="4"/>
              </svg>
            </div>
            <div className={styles.row03}>
              <div className={styles.number03}>
                <span>03</span>
              </div>
              <div className={styles.text03}>
                <h3>Scale up<span>.</span></h3>
                <p>Cuentas con el presupuesto para invertir en tecnología y quieres escalar tu idea. Ya no estás probando si funciona el concepto, ya tienes el modelo de negocios, el concepto validado y sabes que será un éxito.¡Hagámoslo crecer juntos!</p>
                <a href="/contact"  rel="noreferrer" className={styles.submit}>
                  Empieza ahora
                </a>
              </div>
              <div  className={`${styles.img03} rellaximgfirst`}>
                {mode === "dark" ? (
                    images["DarkIlustration3"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["DarkIlustration3"].publicURL}
                        />
                    )
                ) : (
                    images["LightIlustration3"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["LightIlustration3"].publicURL}
                        />
                    )
                )}
              </div>
            </div>
          </div>
          <div style={{height: '15vh'}} className={`${styles.container02} parallaxwrap1`}>
            <div className={styles.row02}>
              {/*<div  className={`${styles.img02} rellaximgfirst`}>
                {!mobile
                    ? mode === "dark"
                        ? images["DarkIlustration2"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["DarkIlustration2"].publicURL}
                        />
                    )
                        : images["LightIlustration2"] && (
                        <img
                            alt="ilustration_methodology"
                            src={images["LightIlustration2"].publicURL}
                        />
                    )
                    : images["MobileDark2"] && (
                    <img
                        alt="ilustration_methodology"
                        src={images["MobileDark2"].publicURL}
                    />
                )}
              </div>
              <div className={styles.text02}>
                <h3> Proyectos en escala <span>.</span></h3>
                <p> Cada proyecto emplea un equipo de trabajo distinto. Esto nos permite trabajar con una enorme cantidad de proyectos en simultáneo sin demoras.</p>
              </div>
              <div className={styles.number02}>
                <span>04</span>
              </div>*/}
            </div>
          </div>

        </Container>
      </div>
  );
};

export default MethodologyDesktop;
